'use strict';

exports.__esModule = true;
exports.sortOptions = exports.resultStats = undefined;

var _emotion = require('emotion');

var resultStats =
/*#__PURE__*/
(0, _emotion.css)('flex-grow:1;font-size:0.82rem;');
var sortOptions =
/*#__PURE__*/
(0, _emotion.css)('color:#424242;height:32px;font-size:0.82rem;padding:0 25px 0 10px;background:url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 95% 50%;background-color:#fff;-moz-appearance:none;-webkit-appearance:none;appearance:none;-webkit-border-radius:0;border-radius:0;border:0;outline:1px solid #ddd;outline-offset:-1px;');
exports.resultStats = resultStats;
exports.sortOptions = sortOptions;